.customerPanel {
    flex-grow: 1;
    flex-direction: column;
    width: 100%;
    max-width: 400px;
    border-radius: var(--mantine-radius-md);
    background-color: var(--mantine-color-dark-5);
    position: relative;
    scrollbar-color: var(--mantine-color-gray-7) var(--mantine-color-dark-5);
}

.responsivePanel {
    display: flex;
    flex: 1;
    flex-direction: column;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-color: var(--mantine-color-gray-7) var(--mantine-color-dark-5);
}

.topSection {
    flex-direction: column;
    margin: 12px;
    margin-bottom: 0;
}

.profilePicture {
    max-height: 50px;
    max-width: 50px;
    border-radius: 100%;
    margin-right: var(--mantine-spacing-sm);
}

.editButton {
    align-self: flex-end;
    margin-bottom: -30px;
}

.name {
    max-width: 200px;
    font-weight: 700;
}

.customerIdentifier {
    color: var(--mantine-color-dark-1);
    line-height: 20px;
}

.customerCaseNumber {
    line-height: 20px;
}

.root {
    width: 100%;
    align-self: center;
    overflow-y: auto;
    margin-top: 5px;
    height: 100%;
}

.divider {
    --divider-size: var(--divider-size-md);
}

.tabPanel {
    height: calc(100% - 42px);
    overflow-y: auto;
}

.cardGrid {
    padding: 1rem;
}
.tab {
    width: 50%;
    justify-content: center;
}
.tabHeader {
    align-items: center;
    gap: 0.5rem;
}
